import React from 'react';
/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  a,
  l,
  BoxC,
  IptC,
  LblC,
  GridC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as GridC from "./_cccGridC";
import * as LblC from "./_cccLblC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';
import * as hf from './_hf';
import * as ihd from './ihd';

export const N = (pz: {
  sPz: ht.dz,
  boxStlz: ht.dz,
  cz: {
    i1zz: ht.dz,
    onChgAsync: ( _dz: ht.dz ) => void,
  }
}) => {

//hf.l(`icvI1zS11Co3b 34: here`);
  return (
    cr.c(BoxC.N, {
      key: 'Iccv23b4b.root',
      boxStlz: {
        ... a('dw/f'),
        ... pz.boxStlz
      },
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'nolineCmnz',
          lineCs: [
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        boxStlz: a('dw/18'),
                        textz: {
                          pfx: '予約受付票：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: false,
                              iptType: 'text',
//                              vle: pz.cz.i1zz.i1zrz._icn,
                              vle: '（予約ID）' + (pz.cz.i1zz.i1zrz._icn ?? ''),
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
//                        boxStlz: a('pl/1 mr/1'),
                        textz: {
                          pfx: '登録日：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'dtm',
                              vle: pz.cz.i1zz.i1zrz.i1zrd1100s,
//                              vle: hfDTM.getTdy(),
                              onChg: ( _s: ht.s ) => {
                                pz.cz.i1zz.i1zrz.i1zrd1100s = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
                          {
                            abtType: 'omtRqrCmnz',
                          }
                        : null,
                    }),
                  ]
                },
/*
                {
                  boxStlz: a(`f/1`),
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        boxStlz: a('dw/8'),
                        textz: {
                          pfx: '経路：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: false,
                              iptType: `pcr`,
                              ls: ihd.f('i1zra6100i').ls,
                              vle: pz.cz.i1zz.i1zrz.i1zra6100i ?? -1,
                            }
                          })
                        ],
                      },
                    }),
                  ]
                },
*/

              ]
            },

            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      boxStlz: 
                        hf.i(pz.cz.i1zz.i1zrz.i1zrs1100i, [20,22,24,26]) ?
                          a(`sc/rd5`)
                        : undefined,
                      lblCz: {
                        boxStlz: a('dw/18'),
                        textz: {
                          pfx: '状況：',
                          stlz: 
                            hf.i(pz.cz.i1zz.i1zrz.i1zrs1100i, [20,22,24,26]) ?
                              a(`tc/lt1`)
                            : undefined,
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: false,
                              iptType: 'pcr',
                              vle: pz.cz.i1zz.i1zrz.i1zrs1100i,
                              ls: ihd.f('i1zrs1100i').ls,
                            },
                            iptStlz: {
                              showz: 
                                hf.i(pz.cz.i1zz.i1zrz.i1zrs1100i, [20,22,24,26]) ?
                                  a(`tc/lt1 tb`)
                                : undefined,
                            }
                          }),
                        ],
                      },
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        boxStlz: a('dw/8'),
                        textz: {
                          pfx: '経路：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: false,
                              iptType: `pcr`,
                              ls: ihd.f('i1zra6100i').ls,
                              vle: pz.cz.i1zz.i1zrz.i1zra6100i ?? -1,
                            }
                          })
                        ],
                      },
                    }),
                  ]
                },
              ]
            },

            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        boxStlz: a('dw/18'),
                        textz: {
                          pfx: '申込者：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
//                              bRqr: true,
                              iptType: 'text',
                              vle: pz.cz.i1zz.i1zrz.i1zra2100s,
                              onChg: ( _s: ht.s ) => {
                                pz.cz.i1zz.i1zrz.i1zra2100s = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
                          {
                            abtType: 'omtRqrCmnz',
                          }
                        : null,
                    }),
                  ]
                },
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
//                        boxStlz: a('pl/1 mr/1'),
                        textz: {
                          pfx: '申込日：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'dtm',
                              vle: pz.cz.i1zz.i1zrz.i1zrd2100s,
                              onChg: ( _s: ht.s ) => {
                                pz.cz.i1zz.i1zrz.i1zrd2100s = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
                          {
                            abtType: 'omtRqrCmnz',
                          }
                        : null,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        boxStlz: a('dw/18'),
                        textz: {
                          pfx: '連絡先電話番号：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: pz.cz.i1zz.i1zrz.i1zra3100s,
                              onChg: ( _s: ht.s ) => {
                                pz.cz.i1zz.i1zrz.i1zra3100s = _s;
                              },
                            }
                          })
                        ],
                      },
/*
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
                          {
                            abtType: 'omtRqrCmnz',
                          }
                        : null,
*/
                    }),
                  ]
                },
                {
                  oClds: [
                    pz.sPz.crt.ctt == 'r' ?
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      boxStlz: a('sc/yw3'),
                      lblCz: {
                        abtType: 'hzlStfz',
//                        boxStlz: a('sc/yw3 pl/1 mr/1'),
                        textz: {
                          pfx: '支払期限：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'dtm',
                              vle: pz.cz.i1zz.i1z3z.i1z3d1100s,
                              onChg: ( _s: ht.s ) => {
                                pz.cz.i1zz.i1z3z.i1z3d1100s = _s;
                              },
                            }
                          })

                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
                          {
                            abtType: 'omtRqrCmnz',
                          }
                        : null,
                    })
                    : null,
                  ]
                },
              ]
            },
          ]
        }),

      ]
    })
  );
};
 